import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Input, Inject } from '@angular/core';
import { HomepageService } from '../../../services/homepage.service';
import { AuthService } from '../../../services/auth.service';
import { SafeUrl } from '@angular/platform-browser';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { WidgetSettingsService } from '../../../services/widget-settings.service';
import { CookieService  } from 'ngx-cookie-service';
import { NotifierService } from 'angular-notifier';
@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css']
})
export class BannerComponent implements OnInit {
 @Input() public Banner: SafeUrl = 'inner'; 
 @Input() public bannerText: SafeUrl = ''; 
 banner: any = [];
 bannerSubText : any = '';
 bannerChoose : any[] = [];
 bannerChooseShow : boolean = false;
 fileToUpload: File = null;
 theme:any = 'default';
 imageError:any = '';
 private readonly notifier: NotifierService;
 constructor( notifierService: NotifierService, private authService: AuthService, private homepageService: HomepageService,@Inject(DOCUMENT) private document: Document,private activatedRoute: ActivatedRoute, private router: Router, private widgetSettingsService: WidgetSettingsService, private cookieService: CookieService ) {
  this.notifier = notifierService;
 	this.router.events.subscribe((val) => {
    	this.homepageService.updateBannerText('');
    	this.homepageService.bannerText$.subscribe(resultList => {
     		this.bannerSubText = resultList;
     	});
    });
    //Getting inner banner text.
    this.activatedRoute.params.subscribe(params => {	
    	this.homepageService.bannerText$.subscribe(resultList => {
     		this.bannerSubText = resultList;
     	});
    });
    //checking for theme to change inner banner and other attributes.
    this.homepageService.theme$.subscribe(theme => {
      //console.log(theme, '++++++++');
      this.theme = theme;
    });
 }
 
  ngOnInit() {
    if(localStorage.getItem('theme') !== null){
      this.theme = localStorage.getItem('theme');
    }
    this.getpopularlist();       
  }

  getpopularlist(){
    this.banner = this.homepageService.getUpdatedConfig();    
  }

 //open modal to edit logo
 editLogobanner(event){
  //var updateBanner = $('#origin-banner').val().toString();
  //$('.hero-home').find('.hero-img').attr('src',updateBanner);
   if($(event.target).hasClass('editLogobanner')){
    $(event.target).toggleClass('open').next('.editLogobannerContent').toggleClass('open');
   } else {
    $(event.target).parent().toggleClass('open').next('.editLogobannerContent').toggleClass('open');
   }  
 }

  //Selecting banner and changing instantly on site.
  selectBanner(event){
    var bannerImage = $(event.target).next('input').val().toString();
    $(event.target).parents('ul').find('li').removeClass('selected');
    $(event.target).parent().addClass('selected');
    $('#origin-banner-temp').val(bannerImage);
    if(bannerImage != ''){
      $('.hero-home').find('.hero-img').attr('src',bannerImage);
    } else {
      if(this.theme == 'playground' || this.theme == 'birthdayCake')
      $('.hero-home').find('.hero-img').attr('src','/assets/theme/light/img/banner-main/header-kids1-img.jpg');
      else if(this.theme == 'beach')
         $('.hero-home').find('.hero-img').attr('src','/assets/theme/light/img/banner-main/beach.jpg');
      else
      $('.hero-home').find('.hero-img').attr('src','/assets/theme/light/img/banner-main/header-img.jpg');
      $('#origin-banner').val('');
    }
    $('#closeBannerChoose').trigger('click');
    this.bannerChooseShow = false;
  }

  //Getting banner list
  visibleChoseBanner(){
    ////if(this.cookieService.check( 'info')){
    //if (localStorage.getItem('info') != null){
      var token =  localStorage.getItem('token');
    //}else{
      //this.notifier.notify('error', 'Session expired! Please login again.');
      //this.logOut();
    //}
    this.widgetSettingsService.bannerListGet(token).subscribe((data) => {
      this.bannerChoose = data;
      //console.log(data);
      if(data.status){
        this.bannerChooseShow = true;
      }
    },(error)=>{
        this.notifier.notify('error', "Sorry! Someting isn't working as expected");
    });
  }

  //upload banner
  uploadImage(files: FileList) {
    this.bannerChooseShow = true;
    $('#bannerSave').attr('disabled','disabled');
    $('#bannerCancel').attr('disabled','disabled');
    this.fileToUpload = files.item(0);
    var validImageTypes = ["image/gif", "image/jpeg", "image/png", "image/jpg"];
    var fileType = this.fileToUpload.type;
    var fileSizeTemp = this.fileToUpload.size;
    var fileSize = Math.round((fileSizeTemp)/(1024*1024));
    if ($.inArray(fileType, validImageTypes) < 0) { //Checking if file is of valid type.
      this.imageError = 'Please use "jpeg", "jpg", "png" or "gif" image formats only.';
      $('#imageErrorBanner').addClass('show');
      $('#bannerSave').removeAttr('disabled');
      $('#bannerCancel').removeAttr('disabled');
      this.bannerChooseShow = false;
      return false;
    }
    if(fileSize >= 3){ //checking if image is greater then 3 MB.
      this.imageError = 'Image size should be less than 3 MB.';
      $('#imageErrorBanner').addClass('show');
      $('#bannerSave').removeAttr('disabled');
      $('#bannerCancel').removeAttr('disabled');
      this.bannerChooseShow = false;
      return false;
    }
    let formData = new FormData(); 
    formData.append('file', this.fileToUpload, this.fileToUpload.name); 
    $('span.bannerUploaderSpan').text('Uploading..');
    ////if(this.cookieService.check( 'info')){
    //if (localStorage.getItem('info') != null){
      var token =  localStorage.getItem('token');
    //}
    this.widgetSettingsService.bannerUpload(token,formData).subscribe((data) => {
      $('span.bannerUploaderSpan').text('Upload Library Banner');
      if(data.status){
       $('.hero-home').find('.hero-img').attr('src',data.data.link);
       $('#origin-banner-temp').val(data.data.link);
        this.saveBannerSection($('#bannerSave'));
      }
    },(error)=>{
       if(error.status == 400){
        this.notifier.notify('error', 'Session expired! Please login again.');
      }else{
        this.notifier.notify('error', "Sorry! Someting isn't working as expected");
      }
    });
   }

//save selected banner.
saveBannerSection(event){
   $('#bannerSave').text('Saving...').attr('disabled','disabled');
   $('#bannerCancel').attr('disabled','disabled');
    if($.trim($('#origin-banner-temp').val().toString()) != '' ) {
      $('#origin-banner').val($('#origin-banner-temp').val());
      $('#origin-banner-temp').val('');
    }
    var line1 = $('#bannerLine1').val();
    var line2 = $('#bannerLine2').val();
    var image = $('#origin-banner').val();
    var isSmall = $('#smallBanner').val();
    //console.log(isSmall);
    ////if(this.cookieService.check( 'info')){
    //if (localStorage.getItem('info') != null){
      var token = localStorage.getItem('token');
    //}
    this.widgetSettingsService.saveBannerSection(line1,line2,image,isSmall,token).subscribe((data) => {
      this.homepageService.getConfig().subscribe((data) => {
        this.bannerChooseShow = false;
        this.banner = data;
        $('#bannerSave').text('Save').removeAttr('disabled');
        $('#bannerCancel').removeAttr('disabled');
        $('.editLogobanner.banner').toggleClass('open').next('.editLogobannerContent').toggleClass('open');
      });      
    },(error)=>{
       if(error.status == 400){
        this.notifier.notify('error', 'Session expired! Please login again.');
        //this.logOut();
      }else{
        this.notifier.notify('error', "Sorry! Someting isn't working as expected");
      }
    }); 
}

closeModal(){
  this.bannerChooseShow = false;
}

  closeImageError(){
    $('#imageErrorBanner').removeClass('show');
    this.imageError = '';
  }

  logOut(){
    $('#myCollectionLi').find('.my-list-count').text('0');
    $('#profileLi').removeClass('show').addClass('hide');
    $('#loginLi').removeClass('hide').addClass('show');
    $('.widgets.select-box').css('min-height','auto');
    $('.SearchResults').find('.count').text('0');
    this.cookieService.deleteAll('/');
    this.document.body.classList.remove('login-patron');
    this.document.body.classList.remove('manage-view');
    localStorage.removeItem('selectedResourcesIds');
    localStorage.removeItem('token');
    localStorage.removeItem('requireChange');
    localStorage.removeItem('isNonComplaint');
    this.router.navigate(['/']);
  }

  smallBannerChange(event){
    //console.log($(event.target).val());
    if($(event.target).val() == 'small'){
      $('.hero').addClass('small-banner');
      $('.hero').removeClass('medium-banner');
    }else if($(event.target).val() == 'medium'){
      $('.hero').removeClass('small-banner');
      $('.hero').addClass('medium-banner');
    }else{
      $('.hero').removeClass('small-banner');
      $('.hero').removeClass('medium-banner');
    }
  }

}